import overrideAutocompleteStyles from "./Autocomplete";


const overrideAnalyticComponents = theme => Object.assign(
	overrideAutocompleteStyles(theme)
)

export default overrideAnalyticComponents;